import { Component, Input, HostListener } from '@angular/core';

export interface MenuOption {
  label: string;
  action: () => void;
  icon?: string;
  iconColor?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-button-menu',
  templateUrl: './button-menu.component.html',
  styleUrls: ['./button-menu.component.css']
})
export class ButtonMenuComponent {

  @Input() options: MenuOption[] = [];
  @Input() optionsIcons: MenuOption[] = [];
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() outline: boolean = false;
  @Input() icon: string = '';
  @Input() colorIcon: string = '#000';
  @Input() widthPx: number;
  @Input() specialWidth: number;

  isMobile: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = window.innerWidth <= 768;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  executeAction(option: MenuOption) {
    if (!option.disabled && option.action) {
      option.action();
    }
  }
}